<template>
    <div >
        <!--  BEGIN NAVBAR  -->
        <div class="header-container fixed-top">
            <header class="header  navbar navbar-expand-sm bg-white navbar-light" >
                <div class="navbar-item flex-row ms-md-0 ms-auto">
                    <ul class="navbar-item theme-brand flex-row text-center">
                        <li class="nav-item theme-logo">
                            <router-link to="#">
                              <h4 class="fw-bolder mobile-hidden" >BUSHMAN SAFARI TRACKERS ERP</h4>  
                                <!-- <img :src="require(`@/assets/images/logo.png`)" class="navbar-logo" alt="logo" style="width: 150px; height: auto;" /> -->
                            </router-link>
                        </li>
                    </ul>
                </div>
        
                <div class="navbar-item flex-row ms-md-auto ">
                   
<!-- notification starts -->
 
                    <div class="dropdown nav-item notification-dropdown btn-group">
<div class="dropdown nav-item notification-dropdown btn-group" style="position: relative;" ref="notifDropdownRef">
               <div class="d-flex align-items-center gap-3">
                             <span class="ms-3 badge bg-secondary">
  Logout in: {{ minutes }}:{{ seconds < 10 ? '0' + seconds : seconds }}
</span>

                             <!-- <button 
                                class="btn btn-primary refresh-btn rounded-circle p-2" 
                                @click="refreshPage" 
                                title="Refresh page"
                                :class="{ 'spin-animation': isRefreshing }"
                                :disabled="loading"
                                style="width: 2.5rem; height: 2.5rem;"
                            >
                            <span v-if="loading" v-html="loadingSpinner()">

                            </span>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="16" 
                                    height="16" 
                                    fill="currentColor" 
                                    class="bi bi-arrow-clockwise" 
                                    viewBox="0 0 16 16"
                                >
                                    <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                </svg>
                            </button> -->
                            <!-- notification bell starts --
                            <div class="nav-link position-relative" @click.stop="showNotif = !showNotif">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="red" class="bi bi-bell vibrate" viewBox="0 0 16 16">
          <path d="M8 16a2 2 0 0 0 1.985-1.75H6.015A2 2 0 0 0 8 16zm.104-14.804a1 1 0 0 0-1.208 0A5.002 5.002 0 0 0 3 6c0 1.098-.628 2.064-1.528 2.625A.5.5 0 0 0 2 9.5h12a.5.5 0 0 0 .528-.875C13.628 8.064 13 7.098 13 6a5.002 5.002 0 0 0-3.896-4.804z"/>
        </svg>
        <span class="position-absolute top-0 start-100 translate-middle">
          <span class="bg-danger rounded-circle" style="width: 8px; height: 8px; display: inline-block;"></span>
        </span>
      </div>
      notification bell ends -->
        </div>
  <div v-if="showNotif" class="card shadow" style="position: absolute; right: 0; top: 100%; min-width: 260px; max-width: 320px; z-index: 1000;">
    <div class="card-header bg-light text-dark">
      <h6 class="mb-0">Notifications</h6>
    </div>
    <div class="card-body p-x-1" style="max-height: 30vh; overflow-y: auto;">
      <div v-for="notification in notifications" class="text-start ">
        <div class="d-flex">
           {{notification.name}}
          <div class="ms-auto">2</div>
        </div>
       <hr class="border-danger border border-3" />
      </div>
    </div>
  </div>
</div>
                    </div>
 <!-- notification ends -->


                    <div class="dropdown nav-item user-profile-dropdown btn-group">
                        <a  href="javascript:;" id="ddluser" data-bs-toggle="dropdown" aria-expanded="false" class="btn dropdown-toggle btn-icon-only user nav-link">
                         
                        <strong><span class="nav-link text-dark " style="font-size: 1em; font-weight: bold;">{{ user ? user.name : "Guest" }}</span></strong>
   
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ddluser">
                            <li role="presentation">
                                <router-link to="/user/profile" class="dropdown-item">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-user"
                                    >
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="12" cy="7" r="4"></circle>
                                    </svg>
                                    Profile
                                </router-link>
                            </li>
                            <li role="presentation">
                                <a href="javascript:void(0);"  @click="signOut" class="dropdown-item">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-log-out"
                                    >
                                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                        <polyline points="16 17 21 12 16 7"></polyline>
                                        <line x1="21" y1="12" x2="9" y2="12"></line>
                                    </svg>
                                    Sign Out 
                                </a>
                            </li>
                        </ul>
                    </div>
                    
                </div>
            </header>
        </div>
        <!--  END NAVBAR  -->
        <!--  BEGIN NAVBAR  -->
        <div class="sub-header-container">
            <header class="header navbar navbar-expand-sm">
                <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-menu"
                    >
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </a>
<svg 
  @click="goBack(-1)"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 16 16"
  width="80"
  height="28"
  style="
    cursor: pointer;
    margin-left: 80px;
    transition: all 0.3s ease;
    color: #4a5568;
    padding: 6px;
    border-radius: 8px;
    background: linear-gradient(135deg, #f1f5f9 0%, #cbd5e1 100%);
    box-shadow: 
      0 2px 4px rgba(0, 0, 0, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.8);
  "
  onmouseover="this.style.color='#2d3748'; this.style.transform='translateX(-2px)'; this.style.boxShadow='0 4px 8px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.9)'"
  onmouseout="this.style.color='#4a5568'; this.style.transform='translateX(0)'; this.style.boxShadow='0 2px 4px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.8)'"
>
  <path 
    fill-rule="evenodd" 
    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
  />
</svg>
                <!-- Portal vue/Teleport for Breadcrumb -->
                <div id="breadcrumb" class="vue-portal-target"></div>
            </header>
            
        </div>
        
        <!--  END NAVBAR  -->
        <!--  BEGIN TOPBAR  -->
        <div class="topbar-nav header navbar " role="banner" >
            <nav class="topbar">
              <span v-if="loading" v-html="pillShimmer()"></span>
                <ul
                v-else
                class="list-unstyled menu-categories" id="topAccordion">

                    <!-- header starts -->
             
<!-- header from database starts -->

                         <li 
                         v-for="menu in menus"
                         v-bind="corkHeader"
                         >
                        <router-link 
                        v-if="!menu.permission || user_permissions.includes(menu.permission)"
                        :to="menu.path"  class="dropdown-toggle">
                            <div class="">
                                  <span v-html="menu.svg"></span>
                               <span>{{ (`${menu.name}`) }}</span>
                            </div>
                            <svg
                            v-if="menu.child_menus.length>0"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </router-link>
                        <ul
                        v-if="menu.child_menus.length>0" class="collapse submenu list-unstyled">
                            <li  v-for="child in menu.child_menus" class="sub-sub-submenu-list">
                                <router-link 
                                  v-if="!child.permission || user_permissions.includes(child.permission)"
                                :to="child.path" >
                                    {{ child.name }}
                                    <svg
                                    v-if="child.sub_child_menus.length>0"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </router-link>
                                <ul v-if="child.sub_child_menus.length>0" class="collapse list-unstyled sub-submenu">
                                    <li
                                    v-for="subchild in child.sub_child_menus"
                                    ><router-link 
                                     v-if="!subchild.permission || user_permissions.includes(subchild.permission)"
                                    :to="subchild.path">{{ subchild.name }}</router-link></li>
                                </ul>
                            </li> 
                        </ul>
                    </li>   

<!-- header from database ends -->
 <!-- alert modal starts -->
<div class="modal fade mymodal" id="pop-modal" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">MESSAGE</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close"></button>
      </div>
      <div class="modal-body"></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger btn-sm py-2 px-2" data-bs-dismiss="modal">Close</button>
        <router-link to="/inquiry" class="btn btn-primary btn-sm">View</router-link>
      </div>
    </div>
  </div>
</div>

<button  data-bs-toggle="modal" data-bs-target="#pop-modal" id="popper" style="display: none;"></button>
  <!-- alert modal ends -->

                </ul>
            </nav>
        </div>
        <!--  END TOPBAR  -->

        
    </div>
</template>

<script setup>
    import { onMounted, ref,inject,computed,onBeforeUnmount } from 'vue';
    import { useRouter } from 'vue-router';
    import axios from 'axios';
    const router = useRouter();
    const showError = inject('showError');
    const showMessage = inject('showMessage');
    const pillShimmer = inject('pillShimmer');
    const loading = ref(false)
const notifDropdownRef = ref(null);
    const showNotif = ref(false);
const summary = ref(null);

const countdown = ref(3600); // 1 hour in seconds
const minutes = ref(0);
const seconds = ref(0);
let timer = null;

function updateTime() {
  minutes.value = Math.floor(countdown.value / 60);
  seconds.value = countdown.value % 60;
}

const goBack = () => {
  const previous = window.history.state?.back
  if (!previous || previous === '/') return
  router.back()
}


onMounted(() => {
  updateTime();
  timer = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--;
      updateTime();
    } else {
      clearInterval(timer);
      localStorage.removeItem("user");
      localStorage.removeItem('popped');
      router.push('/');
    }
  }, 1000);
});

onBeforeUnmount(() => {
  clearInterval(timer);
});

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
});

function handleClickOutside(event) {
  if (
    showNotif.value &&
    notifDropdownRef.value &&
    !notifDropdownRef.value.contains(event.target)
  ) {
    showNotif.value = false;
  }
}


    const signOut = () => {
        const message = JSON.parse(localStorage.getItem('user')).name + ' logged out';
        const receiver = '255698267662'
        const message_id = 'wamid.HBgMMjU1Njk4MjY3NjYyFQIAEhgWM0VCMDE4NkNGOENGMzEwRDNGQzJFRAA='
        whatsappAlert(message,message_id,receiver)

        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('popped');
        router.push('/');
        refreshPage()
    };
       onMounted(() => {
      getMenus()
      
const checkPopup = setInterval(async () => {
  // await getNotifications();
  if (notifications.value > 0 && !localStorage.getItem('popped')) {
    const modal = new bootstrap.Modal(document.getElementById('pop-modal'));
    modal.show();
    localStorage.setItem('popped', 'true');
  }
}, 50000);


  onBeforeUnmount(() => clearInterval(checkPopup));
    });
    
    onBeforeUnmount(() => {
  document.removeEventListener('mousedown', handleClickOutside); // Clean up
});


    const menus = ref([])
    const getMenus = async ()=>{
      loading.value = true
       try{
          const response = await axiosInstance.get('menus')
          menus.value = response.data
       }catch(error){
        console.log(error)
        showError("In header" + error.message)
       }finally{
        loading.value = false
       }
    }
    
const user = ref(null);
const user_role = ref('');
const user_permissions = ref([]);
const isRefreshing = ref(false);


const notifications = ref(0)
const getNotifications = async()=>{
   const response = await axiosInstance.get(`notifications`)
   notifications.value = response.data
}

const corkHeader = ref('')
const getCorkHeader = async()=>{
   const response = await axiosInstance.get(`header-styles`)
   corkHeader.value = response.data
}


const whatsappAlert = inject('whatsappAlert')
onMounted( async () => {
  await getCorkHeader()
  const storedUser = localStorage.getItem("user");
  if (!storedUser) {
    router.push('/');
  }
  if (storedUser) {
    user.value = JSON.parse(storedUser);
    user_role.value = user.value.role;
    user_permissions.value = user.value.permissions;
  }


    setTimeout(() => {
        const message = JSON.parse(localStorage.getItem('user')).name + ' was logged out';
        const receiver = '255698267662'
        const message_id = 'wamid.HBgMMjU1Njk4MjY3NjYyFQIAEhgWM0VCMDE4NkNGOENGMzEwRDNGQzJFRAA='
        whatsappAlert(message,message_id,receiver)


      localStorage.removeItem("user");
      localStorage.removeItem('popped');
      router.push('/');
      refreshPage()
    }, 3600000); 

let currentModal = null;
let autoCloseTimeout = null;



const popupInterval = setInterval(async () => {
//  await  getNotifications()
},180000);

onBeforeUnmount(() => {
  clearInterval(popupInterval);
  clearTimeout(autoCloseTimeout);
  if (currentModal) currentModal.hide();
});



});


const loadingSpinner = inject('loadingSpinner')
const refreshPage = () => {
  loading.value = true
    window.location.reload();
};



</script>
<style>
@media (max-width: 768px) {
  .mobile-hidden {
    display: none;
  }
}

.notification-bell .notif-dropdown {
  min-width: 260px;
  max-width: 320px;
  max-height: 80vh;
  overflow-y: auto;
  border: 1px solid #eee;
  z-index: 2000;
}

        .vibrate {
      animation: vibrate 1.5s infinite;
        }
        @keyframes vibrate {
          0% { transform: translate(0); }
          25% { transform: translate(-2px, 2px); }
          50% { transform: translate(2px, -2px); }
          75% { transform: translate(-2px, -2px); }
          100% { transform: translate(2px, 2px); }
        }
    
</style>